<template>
  <v-container>
    <v-flex max-width="600">
      <EcrmTable/>
    </v-flex>
  </v-container>
</template>

<script>
  import EcrmTable from '@/components/EcrmTable'
 

  export default {
    name: 'ecrm-registration',
    components: {
      EcrmTable,
    }
  }
</script>